import React from 'react';

export default React.createContext({
  client: null,
});
